import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { Box, Stack, Tooltip } from '@mui/material';

import { Invoice } from '@/api/invoices';

import { DisplayCurrency } from '../DisplayCurrency';

export const InvoiceAmount = ({ invoice, noSourceTooltip }: { invoice: Invoice; noSourceTooltip: boolean }) => {
    const stillDue = invoice.status !== 'paid';
    // negative value of paidFromCreditBalance means the money were given to the customer
    const paidFromCreditBalance = (invoice.starting_balance - invoice.ending_balance) * -1;
    const paidFromPaymentMethod = stillDue ? invoice.amount_remaining : invoice.amount_paid;
    const paidOrDueLabel = stillDue ? 'Due' : 'Paid';

    const showPaidFromCreditBalance = paidFromCreditBalance !== 0;
    const showPaidFromPaymentMethod = paidFromPaymentMethod !== 0;
    const showZeroTotal = !showPaidFromCreditBalance && !showPaidFromPaymentMethod && invoice.total === 0;

    return (
        <Stack spacing={1}>
            {showPaidFromCreditBalance && (
                <Tooltip
                    title={
                        noSourceTooltip
                            ? null
                            : `${paidFromCreditBalance < 0 ? 'Refunded to' : `${paidOrDueLabel} from`} your account balance`
                    }
                >
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                        <DisplayCurrency
                            value={paidFromCreditBalance}
                            cents
                            currency={invoice.currency}
                            negativeValuesBehavior="parentheses"
                        />
                        <AccountBalanceWalletOutlinedIcon
                            fontSize="small"
                            sx={{ ml: 0.5, position: 'relative', bottom: 2 }}
                        />
                    </Box>
                </Tooltip>
            )}
            {showPaidFromPaymentMethod && (
                <Tooltip title={noSourceTooltip ? null : `${paidOrDueLabel} from your selected payment method`}>
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                        <DisplayCurrency
                            value={paidFromPaymentMethod}
                            cents
                            currency={invoice.currency}
                            negativeValuesBehavior="parentheses"
                        />
                    </Box>
                </Tooltip>
            )}
            {showZeroTotal && (
                <Box>
                    <DisplayCurrency
                        value={invoice.total}
                        cents
                        currency={invoice.currency}
                        negativeValuesBehavior="parentheses"
                    />
                </Box>
            )}
        </Stack>
    );
};
